import { connect } from 'react-redux';
import { IAppState } from '../../../../common/state';
import {
  FDealType,
  offerTypeFromJsonQuery,
  dealTypeFromJsonQuery,
  isUrban,
  isSuburban,
} from '../../../../utils/category';
import { SALE_URBAN_ORDER, SALE_SUBURBAN_ORDER, RENT_URBAN_ORDER, RENT_SUBURBAN_ORDER } from './params/orders';

import { getParams, IParam, IParams } from './params';
import { AdvancedFilters as AdvancedFiltersComponent } from './advancedFilters';

export const mapStateToProps = (state: IAppState) => {
  const {
    filters: { jsonQuery, currentLocation },
  } = state;
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const dealType = dealTypeFromJsonQuery(jsonQuery);

  const allParams = getParams({ jsonQuery, offerType, dealType, currentLocation });
  let params: [keyof IParams, IParam][] = [];

  const mapParam = (key: keyof IParams): [keyof IParams, IParam] => [key, allParams[key]];

  if (dealType === FDealType.Sale) {
    if (isUrban(offerType)) {
      params = SALE_URBAN_ORDER.map(mapParam);
    } else if (isSuburban(offerType)) {
      params = SALE_SUBURBAN_ORDER.map(mapParam);
    }
  } else {
    if (isUrban(offerType)) {
      params = RENT_URBAN_ORDER.map(mapParam);
    } else if (isSuburban(offerType)) {
      params = RENT_SUBURBAN_ORDER.map(mapParam);
    }
  }

  return {
    offerType,
    dealType,
    params,
  };
};

export const AdvancedFilters = connect(mapStateToProps)(AdvancedFiltersComponent);
